<div *ngIf="messageBody?.length" class="alert alert-success message-block" [ngClass]="{
    'alert-success': messageTitle == 'Success',
    'alert-danger': messageTitle == 'Failed',
    'alert-info': messageTitle == 'Information'
  }">
    <button type="button" class="close-icon" (click)="closeMessage()">
        <span class="material-icons">close</span>
    </button>
    <strong>{{ messageTitle }}</strong>:
    <span class="mx-1">{{ messageBody }}</span>
</div>
<div class="appLayout workRequest">
    <div class="requestedlog">
        <div style="display: flex;">
            <span class="title" style="width: 90%;">List of Queued Reports</span>
            <div class="refreshButton" matTooltip="Refresh" (click)="refresh()">
                Refresh
            </div>
        </div>
        <div class="requestTable" style="margin-top: 20px !important;">
            <table mat-table [dataSource]="queuedReportsdataSource" class="mat-elevation-z8 queuesTable" matSort
                id="excel-table" #empTbSort="matSort">
                <ng-container matColumnDef="ReportStatus">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Report Status</th>
                    <td mat-cell *matCellDef="let row">{{ row.ReportStatus }}</td>
                </ng-container>

                <ng-container matColumnDef="ErrorMessage">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Error</th>
                    <td mat-cell *matCellDef="let row">{{ row.ErrorMessage }}</td>
                </ng-container>

              
                <ng-container matColumnDef="ReportFileName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Report File Name</th>
                    <td mat-cell *matCellDef="let row">
                        <div *ngIf="row.ReportStatus == 'Completed - File Generated'">
                            {{ row.ReportFileName }}
                        </div>
                    </td>  
                </ng-container>

                <ng-container matColumnDef="RequestedDate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        Requested Date
                    </th>
                    <td mat-cell *matCellDef="let row">{{ row.RequestedDate }}</td>
                </ng-container>

                <ng-container matColumnDef="UpdatedDate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        Last Updated Date
                    </th>
                    <td mat-cell *matCellDef="let row">{{ row.UpdatedDate }}</td>
                </ng-container>

                <ng-container matColumnDef="Actions">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 8% !important">
                        Actions
                    </th>
                    <td class="logoButton" mat-cell *matCellDef="let row">
                        <!-- <div *ngIf="row.ReportStatus == 'Completed'" mattooltip="Add"
                            class="mat-tooltip-trigger filterButton ng-tns-c194-20 ng-star-inserted" ng-reflect-message="Add"
                            aria-describedby="cdk-describedby-message-3" cdk-describedby-host="">
                            Download Report
                        </div> -->
                        <!-- <div *ngIf="row.ReportStatus == 'Completed'" style="display: flex;justify-content: center;">
                             -->
                        <div *ngIf="row.ReportStatus == 'Completed - File Generated'" style="margin-left: 9px;margin-top: 5px;">
                       
                            <i class="fa fa-file-excel-o download" matTooltip="Download Report"
                                (click)="OnDownloadReport(row.ReportFileName, row.QueuedReportId)"></i>
                        </div>

                        <!-- <div *ngIf="row.ReportStatus === 'Failed' || row.ReportStatus === 'Completed'
                        || row.ReportStatus === 'No Data Found'
                        " style="display: flex;justify-content: center;"> -->
                        <div 
                            *ngIf="row.ReportStatus.includes('Completed')
                            || row.ReportStatus.includes('Failed')
                            || row.ReportStatus.includes('No Data Found')"  
                            style="padding-top:6px;padding-left: 4px;">
                            <div style="padding-left:10px;">
                              <i class="fa fa-trash trash" matTooltip="Delete Report" (click)="DeleteFilter(row.QueuedReportId)"></i>
                            </div>
                          </div>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="queuedReportsColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: queuedReportsColumns"></tr>
            </table>
        </div>
    </div>
</div>
